import CircularProgress from '@material-ui/core/CircularProgress';
import Paper from '@material-ui/core/Paper';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import { PlayIcon } from 'assets/svg/PlayIcon';
import clsx from 'clsx';
import LinkComp from 'components/atoms/LinkComp';
import { MAP_BTN_TITLE_BY_REDIRECT_URL } from 'constants/data';
import { EnumProductGA } from 'constants/Enums/product';
import { DOUBLE_ARROW_ICON, SAME_INGREDIENT, SAME_STORE } from 'constants/Images';
import Image from 'next/image';
import { useRouter } from 'next/router';
import { useEffect, useRef } from 'react';
import 'slick-carousel/slick/slick-theme.css';
import 'slick-carousel/slick/slick.css';
import gtag from 'utils/gtag';
import ImageFallback, { ImageFallbackStatic } from 'utils/ImageFallback';
import useStartGuide from 'zustand-lib/useStartGuide';
import { ListProductForPCWrapper } from './ListProductForPCWrapper';
import styles from './styles.module.css';
const MEGA_SALE = 'MEGA-SALE';

const ListProductWithTitle = ({
  children,
  name = '',
  redirect,
  viewMore,
  viewMoreInTitle = true,
  page = null,
  icon,
  iconWidth,
  iconHeight,
  isBestProducts = false,
  loading = false,
  type = '',
  productsType,
  gap,
  forceShowButtonAtBottom = false,
  backgroundImage,
  config = {},
}) => {
  const { isGuide } = useStartGuide((state) => state);
  const ref = useRef(null);
  const ctaBottomRef = useRef(null);

  const TITLE_ICON = name === 'Sản phẩm cùng nhà bán hàng' ? SAME_STORE : SAME_INGREDIENT;
  const router = useRouter();
  const currentUrl = router.asPath;
  const wrapperRef = useRef(null);
  const isShowBtnAtBottom = (viewMore && productsType === MEGA_SALE) || forceShowButtonAtBottom;
  const defaultConfigCtaText = config?.ctaText || 'Xem tất cả';
  const ctaText = config ? defaultConfigCtaText : MAP_BTN_TITLE_BY_REDIRECT_URL[redirect] || 'Xem tất cả';
  const backgroundCta = config?.backgroundCta || 'linear-gradient(0deg, #078c4e 0%, #29cc80 100%)';
  const ctaTextColor = config?.ctaTextColor;
  const headerImage = config?.headerImage;

  const handleGA = () => {
    if (type === EnumProductGA.SAME_MANUFACTURER) {
      gtag.clickViewAllProductSameManufacturer();
    }

    if (type === EnumProductGA.SAME_INGREDIENT) {
      gtag.clickViewAllProductSameIngredient();
    }
  };

  useEffect(() => {
    if (ref?.current) {
      if (isGuide) {
        ref.current.slickPause();
      } else {
        ref.current.slickPlay();
      }
    }
  }, [isGuide]);

  // This effect to make ctaTextColorConfig with the highest priority (!important css)
  useEffect(() => {
    if (ctaBottomRef?.current && ctaTextColor) {
      ctaBottomRef.current.style.color = ctaTextColor;
    }
  }, []);

  return page === 'PRD_DETAIL' ? (
    <Paper ref={wrapperRef} className={clsx(styles.wrapper, isBestProducts && styles.bestProductsWrapper)}>
      <Box className={clsx(styles.icon_name, isBestProducts && styles.bestProducts)}>
        {icon && <ImageFallbackStatic src={icon} width={iconWidth || 40} height={iconHeight || 40} alt="icon" />}
        <h5 className={clsx(styles.name, isBestProducts && styles.bestProductsName)}>{name}</h5>
        {isBestProducts && (
          <Box className={styles.bestProducts_view_more}>
            <a href={`${redirect}`}>
              <span>Xem tất cả</span>
              <ImageFallbackStatic src={DOUBLE_ARROW_ICON} width={12} height={12} alt="icon" />
            </a>
          </Box>
        )}
      </Box>
      {isBestProducts && <ListProductForPCWrapper gap={gap}>{children}</ListProductForPCWrapper>}

      {!isBestProducts && <ListProductForPCWrapper gap={gap}>{children}</ListProductForPCWrapper>}

      {viewMore && !isBestProducts && (
        <Box className={clsx(styles.view_more)} onClick={handleGA}>
          <LinkComp href={`${redirect}`} color="#0E1983" name="Xem tất cả" />
        </Box>
      )}
    </Paper>
  ) : (
    <>
      {(loading || children?.length > 0) && (
        <div className={clsx(styles.wrapper_media, productsType === MEGA_SALE && styles.wrapperMega)} ref={wrapperRef}>
          <div className={styles.wrapper_media_container}>
            <div
              className={clsx(styles.SliderProductWrap, productsType === MEGA_SALE && styles.backgroundMega)}
              style={{
                ...(backgroundImage ? { backgroundImage: "url('" + backgroundImage + "')" } : {}),
                backgroundSize: '100% 100%',
              }}
            >
              {productsType === MEGA_SALE ? (
                <>
                  {headerImage && (
                    <ImageFallback src={(headerImage)} width={1180} height={74} layout={'intrinsic'} alt="header-image-mega-block" />
                  )}
                </>
              ) : (
                <div className={styles.wrapperTitle} style={{ visibility: name == '' ? 'hidden' : 'visible' }}>
                  <h2 className={clsx(styles.title, styles.wrapperContentTitle)}>
                    {icon}
                    <span className={styles.contentTitle}>{name}</span>
                  </h2>
                  {viewMoreInTitle && (
                    <Box
                      className={styles.seeAllWrapper}
                      onClick={() => {
                        if (productsType === 'THUOC_KE_DON_GIA_TOT') {
                          gtag.clickViewAllThuocKeDonGiaTot({ currentUrl, redirect });
                        }
                      }}
                    >
                      <LinkComp href={`${redirect}`} className={clsx(styles.seeAll)}>
                        {MAP_BTN_TITLE_BY_REDIRECT_URL[redirect] || 'Xem tất cả'}
                        <PlayIcon />
                      </LinkComp>
                    </Box>
                  )}
                </div>
              )}
              {loading ? (
                <Box className={styles.progress}>
                  <CircularProgress size={50} thickness={4} />
                </Box>
              ) : (
                <Stack className={productsType === MEGA_SALE && 'px-[6px]'}>
                  <ListProductForPCWrapper gap={gap}>{children}</ListProductForPCWrapper>
                  {isShowBtnAtBottom && (
                    <Box className={styles.seeAllWrapperMega}>
                      <LinkComp href={`${redirect}`} className={clsx(styles.seeAll)} style={{ background: backgroundCta, color: `${ctaTextColor}` }}>
                        <span ref={ctaBottomRef}>{ctaText}</span>
                      </LinkComp>
                    </Box>
                  )}
                </Stack>
              )}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ListProductWithTitle;
